/* eslint-disable camelcase */
import React, { FC, useEffect, useCallback, useState } from "react"
import { observer } from "mobx-react-lite"
import {
  // ImageStyle,
  ViewStyle,
  TouchableOpacity,
  ActivityIndicator,
  TextStyle,
  Appearance,
  ImageStyle, useWindowDimensions, Platform, TextInput,
} from "react-native"
import {
  Screen, Text,
  AutoImage,
  ListRenderItem,
  JalaIcon,
  FlatList,
  Button,
  ListRenderItemInfo,
  DeleteModal,
  Input,
  JalaLoading,
} from "../../../../components"
import {
  color,
  images, nativeBaseTheme,
} from "../../../../theme"
import { View } from 'native-base'
import { CompositeScreenProps, useIsFocused } from "@react-navigation/native"
import { translate, TxKeyPath } from "../../../../i18n"
import numeral from 'numeral'
import { navigate } from "../../../../navigators"
import { delay } from "../../../../utils/delay"
import { useStores } from "../../../../models"
import { SafeAreaView } from "react-native-safe-area-context"
import { getSnapshot } from "mobx-state-tree"
import JalaAnalytic from "../../../../utils/jala-analytic"

const ROOT: ViewStyle = {
  flex: 1,
}

const EMPTY_CONTAINER: ViewStyle = {
  flexGrow: 1,
  alignItems: 'center',
  justifyContent: 'center'
}

const EMPTY_IMAGE: ImageStyle = {
  // width: 25,
  resizeMode: 'contain',
  height: 120,
  marginBottom: 32
}

const VALUEDATA_CONTAINER: ViewStyle = {
  flexDirection: 'row',
  alignItems: 'center',
  marginBottom: 8,
  marginLeft: 10
}

const VALUEDATA_TITLE_CONTAINER: ViewStyle = {
  width: 130,
  alignSelf: 'center',
  backgroundColor: color.palette.white,
  marginLeft: 5
}

const INDICATOR_LEFT: ViewStyle = {
  marginLeft: 5
}

const TOP_ITEM_CONTAINER: ViewStyle = {
  padding: 12
}

const BOTTOM_ITEM_CONTAINER: ViewStyle = {
  flexDirection: 'row',
  paddingBottom: 12,
  paddingHorizontal: 12,
  alignItems: 'center'
}

const BOTTOM_TEXT: TextStyle = {
  marginHorizontal: 8
}

const BUTTON: ViewStyle = {
  marginVertical: 20,
  marginHorizontal: 17,
  paddingHorizontal: 60,
  paddingVertical: 10
}

const HEADER: ViewStyle = {
  flexDirection: 'row',
  alignItems: 'center'
}

const BACK_BUTTON: ViewStyle = {
  marginLeft: 16,
  marginRight: 12
}

const HEADER_CONTAINER = (height): ViewStyle => ({
  justifyContent: "space-between",
  flexDirection: "row",
  alignItems: 'center',
  backgroundColor: color.primary,
  height: height
})

const TOP_BAR_CONTAINER: ViewStyle = {
  justifyContent: "center",
  alignItems: "center",
  flexDirection: "row"
}

const TOP_BAR_SEARCH_BUTTON: ViewStyle = {
  marginRight: 27,
}

const SUB_HEADER_POND: ViewStyle ={
  flexDirection: 'row',
  alignItems: 'center'
}

const SEARCH_HEADER: ViewStyle = {
  ...SUB_HEADER_POND,
  flex: 1,
}

const TEXT_FIELD: ViewStyle = {
  alignItems: 'center',
  justifyContent: 'center',
  flex: 1,
  marginVertical: 0,
  paddingVertical: 0,
  backgroundColor: 'green',
  minHeight: 35
}

const BTN_CANCEL: ViewStyle = {
  marginHorizontal: 16
}

export const SimulationHeader: FC<CompositeScreenProps<any, any>> = observer(function SimulationHeader(props){
  const { navigation, route } = props;
  const {
    simulationStore: { simulations }
  } = useStores()

  const backIcon = Platform.OS === "ios" ? 'arrow_back_ios' : 'arrow_back';
  const colorScheme = "light"
  const inputRef = React.useRef<TextInput>()
  const isFocused = useIsFocused()

  const data = route && route.params && route.params.data || []
  const headerHeight = 55.8;
  const [ hidden, setHide ] = useState<boolean>(true);
  const handleChangeText = (text) => navigation.setParams({ data: { ...data, text } });
  const handleCancel = () => {
    setHide(!hidden);
    navigation.setParams({data: { ...data, text: "" }})
  }
  const isNotEmpty = simulations.length !== 0

  return (<View backgroundColor={color.primary}>
    <SafeAreaView edges={["top"]} />
    {isFocused && <View style={HEADER_CONTAINER(headerHeight)}>
      {hidden ? (
        <>
          <View style={HEADER}>
            <Button testID="jala:id/back-button" preset="link" textPreset="display1" style={BACK_BUTTON}
                    colorScheme={colorScheme} onPress={navigation.goBack}>
              <JalaIcon name={backIcon} size={25} color={color.palette.white} />
            </Button>
            <Text tx="simulationScreen.title" preset="title2" color={color.palette.white} />
          </View>
          {isNotEmpty && <View style={TOP_BAR_CONTAINER}>
            <Button testID="jala:id/search-button" preset="link" colorScheme="light" style={TOP_BAR_SEARCH_BUTTON}
                    onPress={() => setHide(!hidden)}>
              <JalaIcon name="search" size={24} color={color.palette.white} />
            </Button>
          </View>}
        </>
      ) : (
        <View style={SEARCH_HEADER}>
          <Input ref={inputRef} style={TEXT_FIELD} placeholderTx="simulationScreen.searchSimulation" borderRadius="40px"
                 px="12px" ml="16px" backgroundColor={color.palette.white} onChangeText={handleChangeText} />
          <Button testID="jala:id/cancel-button" preset="link" textPreset="title3" textColor={color.palette.white}
                  style={BTN_CANCEL} onPress={handleCancel} tx="cancel" colorScheme="light" />
        </View>
      )}
    </View>}
  </View>)
})

const EmptyList: FC<{ colorScheme?: "light"|"dark", onCreate?: () => void }> = observer(function EmptyList(props) {
  const { colorScheme, onCreate } = props
  const { height } = useWindowDimensions();

  return (
    <View style={EMPTY_CONTAINER} height={`${height - 16}px`}>
      <AutoImage source={images.empty_simulation} style={EMPTY_IMAGE} />
      <Text preset="title4" tx="simulationScreen.emptyTitle" color={color.palette.gray900} colorScheme={colorScheme} marginBottom="8px" />
      <Text preset="body2" tx="simulationScreen.emptySubtitle" color={color.palette.gray800} colorScheme={colorScheme} textAlign="center" />
      <Button
        testID="jala:id/create-button"
        tx="simulationScreen.createSimulation"
        colorScheme={colorScheme}
        onPress={onCreate}
        style={BUTTON}
      />
    </View>
  )
})

const ValueData: FC<{ colorScheme?: "light"|"dark", title?: string, val?: string, isLast?: boolean, data?: any }> = observer(function ValueData(props) {
  const { colorScheme, title, val, isLast, data } = props

  return (
    <View style={VALUEDATA_CONTAINER}>
      <JalaIcon name="kecerahan-1" size={7} />
      <View style={VALUEDATA_TITLE_CONTAINER}>
        <Text preset="body3" text={translate(title as TxKeyPath)} colorScheme={colorScheme} color={color.palette.gray800} />
      </View>
      <Text preset="title5" text={`: ${val}`} colorScheme={colorScheme} color={color.palette.gray800} />
      {isLast && !data && (<ActivityIndicator size={15} color={color.palette.gray800} style={INDICATOR_LEFT} />)}
    </View>
  )
})

const Item: FC<{ colorScheme?: "light" | "dark", info: ListRenderItemInfo<any> }> = observer(function Item(props) {
  const { colorScheme = "light" || Appearance.getColorScheme(), info } = props;
  const { simulationStore, simulationStore: { loading } } = useStores()
  const {
    item,
    item: { name, area, total_seed, survival_rate, user = {} }
  } = info
  const [ simulationResult, setSimulationResult ] = useState<any>({})

  useEffect(() => {
    simulationStore.calculateSimulation(item).then((response) => setSimulationResult(response))
  }, [item, simulationStore])

  const onPress = useCallback(async () => {
    JalaAnalytic.log('Mobile app: simulation - visited');
    await delay(1);
    simulationStore.set('simulation', simulationStore.simulationToParams(item))
    await delay(1);
    navigate('Home.Stack', 'Home.Simulation.Stack')
  }, [item, simulationStore])

  const onEdit = useCallback(async () => {
    await delay(1);
    simulationStore.set('simulation', simulationStore.simulationToParams(item))
    await delay(1);
    navigate('Home.Stack', 'Home.Simulation.Create', 'isEdit')
  }, [item, simulationStore])

  const onDelete = useCallback(async () => {
    await delay(1);
    simulationStore.deleteSimulation(item.id)
    await delay(1)
  },[item, simulationStore])

  const harvestTotal = simulationResult && simulationResult.totalHarvest ? numeral(simulationResult.totalHarvest.mass).format('0,0.[00]') : '-'

  return (
    <View
      borderRadius="8px"
      borderWidth="0.1px"
      borderColor={colorScheme === 'light' ? 'gray.200' : 'gray.800'}
      backgroundColor={colorScheme === 'light' ? nativeBaseTheme.colors.white : nativeBaseTheme.colors.black}
      shadow="2"
      zIndex="1"
      marginBottom="20px"
      marginX="12px"
    >
      <TouchableOpacity onPress={onPress}>
        <View style={TOP_ITEM_CONTAINER}>
          <Text preset="title5" text={user.name} color={color.primary} colorScheme={colorScheme} mb="8px" />
          <Text preset="title4" text={`${name} - ${numeral(area).format('0,0')} m`} colorScheme={colorScheme} mb="12px" />
          <ValueData title="simulationScreen.totalSeed" val={`${numeral(total_seed).format('0,0')} ${translate('simulationScreen.quantityShort')}`} />
          <ValueData title="simulationScreen.survivalRate" val={`${numeral(survival_rate).format('0,0.[0]')}%`} />
          <ValueData title="simulationScreen.TotalHarvest" val={`${harvestTotal} kg`} isLast data={simulationResult} />
        </View>
      </TouchableOpacity>
      <View style={BOTTOM_ITEM_CONTAINER}>
        <TouchableOpacity onPress={onEdit}>
          <Text preset="title4" tx="simulationScreen.edit" colorScheme={colorScheme} color={color.primary}/>
        </TouchableOpacity>
        <Text text="|" style={BOTTOM_TEXT} />
        <DeleteModal
          testID="jala:id/delete-button"
          deleteModalTitle={translate("simulationScreen.deleteTitle")}
          deleteModalTitleProps={{ color: color.primaryDarker }}
          deleteModalSubtitle={translate("simulationScreen.deleteSubtitle", { simulation: name || '-' })}
          onConfirm={onDelete}
          disabled={loading}
        >
          <Text
            tx="delete"
            preset="title4"
            // color={color.palette.red400}
            colorScheme={colorScheme}
            color={loading ? nativeBaseTheme.colors.muted["500"] : nativeBaseTheme.colors.danger["500"]}
            />
        </DeleteModal>
      </View>
    </View>
  )
})

const Header: FC<{ colorScheme?: "light"|"dark" }> = observer(function Header(props) {
  const { colorScheme } = props;

  return (<View paddingTop="20px" paddingBottom="12px" paddingX="16px">
    <Text preset="title3" tx="simulationScreen.listTitle" colorScheme={colorScheme} />
  </View>)
})

export const SimulationListScreen: FC<{ colorScheme?: "light" | "dark" } & CompositeScreenProps<any, any>> = observer(function SimulationListScreen(props) {
  const { colorScheme = "light" || Appearance.getColorScheme(), route } = props
  const { height } = useWindowDimensions();

  const {
    simulationStore,
    simulationStore: { simulations, loadingSimulation, needRefresh }
  } = useStores()
  const [ filteredSimulation, setFilteredSimulation ] = useState<Array<any>>([])

  useEffect(() => {
    simulationStore.init()
  }, [simulationStore])

  useEffect(() => {
    if(route.params && route.params.data && route.params.data.text) {
      const text = route.params.data.text
      handleSearch(text)
    }
  }, [route])

  useEffect(() => {
    if (needRefresh)
      simulationStore.getSimulations(true, () => {
        simulationStore.set('needRefresh', false);
        simulationStore.set('pushIdQueue', {})
      })
  }, [needRefresh, simulationStore])

  useEffect(() => {
    JalaAnalytic.log('Mobile app: simulation - list');
  }, [])

  const handleSearch = useCallback((text: string) => {
    const result = simulations.filter((item) => {
      const simulationName = item.name.toUpperCase();
      const searched = text.toUpperCase();
      return simulationName.indexOf(searched) > -1;
    })
    setFilteredSimulation(result);
  }, [simulations])

  const onRefresh = useCallback(() => {
    simulationStore.set('needRefresh', true);
  }, [simulationStore])

  const onCreate = useCallback(async () => {
    simulationStore.set('simulation', {})
    simulationStore.set('prices', [])
    simulationStore.set('selectedRegion', null)
    await delay(1)
    navigate('Home.Stack', 'Home.Simulation.Create')
  }, [simulationStore])

  const renderItem: ListRenderItem<any> = useCallback((info) => {
    return <Item info={info} colorScheme={colorScheme} />
  }, [colorScheme])

  const keyExtractor = useCallback((item, index) => `${index}`, [])
  const data = filteredSimulation.length ? filteredSimulation : getSnapshot(simulations)
  const isEmpty = data.length === 0

  return (
    <Screen
      style={ROOT}
      preset="fixed"
      colorScheme={colorScheme}
      backgroundColor={colorScheme === "light" ? color.palette.white : undefined}
      backgroundBar={colorScheme === "light" ? color.primary : undefined}
      statusBar={colorScheme === "light" ? "light-content" : "dark-content"}
    >
      <View flex={1}>
        <FlatList
          data={data}
          renderItem={renderItem}
          keyExtractor={keyExtractor}
          ListEmptyComponent={loadingSimulation && (
            <View flexGrow={1} alignItems="center" justifyContent="center" height={`${height - 216}px`}>
              <JalaLoading />
            </View>
          ) || <EmptyList colorScheme={colorScheme} onCreate={onCreate} />}
          ListHeaderComponent={!isEmpty && <Header colorScheme={colorScheme} />}
          estimatedItemSize={209}
          refreshing={needRefresh || false}
          onRefresh={onRefresh}
        />
      </View>
      {!isEmpty && <View borderTopWidth="1px" borderTopColor="gray.300">
        <Button
          testID="jala:id/create-button"
          tx="simulationScreen.createSimulation"
          colorScheme={colorScheme}
          onPress={onCreate}
          style={BUTTON}
        />
      </View>}
    </Screen>
  )
})

